export default "__VITE_ASSET__BMW6KwiQ__"